module.exports = __webpack_public_path__ + "static/img/medical-zhuanli.2be4c952.png";